import $ from 'jquery'
import { mapGetters, mapActions } from 'vuex'

/**
 * Handle validation functionality
 */
export default ({
  skipValidation
}) => {
  return {
    data: () => ({
      /**
       * @vuese
       * Validator instance
       */
      validator: $.validator.unobtrusive,
      /**
       * @vuese
       * Validation errors
       */
      validationErrors: [],
      externalValidationErrors: {},
      externalValidations: {},
      externalValidationsLoaded: {},
      /**
       * @vuese
       * Track if form is validated
       */
      formValidation: false
    }),
    computed: {
      ...mapGetters('validations', ['validationsEnabled']),
      isValid() {
        return this.skipValidation || this.requiredFilled
      },
      skipValidation() {
        if (this.skipValidationOveride) {
          return !this.skipValidationOveride
        } else {
          return skipValidation
        }
      },
      requiredFilled() {
        return this.requiredInputs.filter(i => !i.haveRequiredValue).length === 0
      },
      externalValid() {
        const values = Object.values(this.externalValidations)
        return values.length === 0 || !values.some((el) => el.includes(false))
      }
    },
    methods: {
      ...mapActions('validations', { validateExternal: 'validate'}),
      ...mapActions('validations', ['getValidationSettings']),
      /**
       * @vuese
       * Parse form validations
       */
      async parseValidation() {
        if (!this.skipValidation) {
          this.validator.parse(this.getSelector())
          await this.getValidationSettings()
          this.getExternalValidations()
        }
      },
      forceValidationError (el, message) {
        const element = $(el)
        const msg = element.data('external-msg')
        const elId = element.attr('id')
        const elType = element.prop('nodeName')
        const errorMsgTag = $(`span[data-valmsg-for="${elId}"]`)
        if(elType !== 'SELECT' || !elId.startsWith('phoneCountryCode')) {
          element.removeClass('valid')
          element.addClass('input-validation-error')
          errorMsgTag.removeClass('field-validation-valid')
          errorMsgTag.addClass('field-validation-error')
          console.log(element, errorMsgTag, msg, message)
          errorMsgTag.text(msg || message)
        }
      },
      getExternalValidations() {
        this.form.find('[data-val-external]').each((i, el) => {
          const element = $(el)
          const validationType = element.data('val-external')
          if (!this.validationsEnabled.includes(validationType)) {
            this.$logger.debug('External validation not enabled: ', validationType)
            return
          }
          if (!this.externalValidations[validationType]) {
            this.$set(this.externalValidations, validationType, [])
            this.$set(this.externalValidationErrors, validationType, [])
            this.$set(this.externalValidationsLoaded, validationType, false)
          }
          element.on('blur', { validationType }, this.onExternalValidation)
          element.on('input', { validationType }, this.resetExternalValidation)
        })
      },
      async onExternalValidation({ data }) {
        const { validationType } = data
        const values = []
        const haveValidValues = []
        const inputs = this.form.find(`[data-val-external="${validationType}"]`)
        if (this.externalValidationsLoaded[validationType]) {
          if (!this.externalValidations[validationType]) {
            inputs.each((i, el) => {
              this.forceValidationError(el, 'Invalid')
            })
            this.$emit('external-error')
          }
          return
        }
        let dontValidate
        let defaultValue = []
        if (validationType === 'email') {
          inputs.each((i, el) => {
            const element = $(el)
            defaultValue.push(element.val())
            haveValidValues.push(element.valid())
          })
          values.push([...defaultValue])
          const haveDifferentValues = [...new Set(values)].length > 1
          dontValidate = haveValidValues.includes(false) || haveDifferentValues
        } else if (validationType === 'phone') {
          let phoneNumber0 = []
          let phoneNumber1 = []
          let phoneNumber2 = []
          inputs.each((i, el) => {
            const element = $(el)
            if(element.prop('name').endsWith('0')) {
              phoneNumber0.push(element.val())
            } else if(element.prop('name').endsWith('1')) {
              phoneNumber1.push(element.val())
            } else if(element.prop('name').endsWith('2')) {
              phoneNumber2.push(element.val())
            } else {
              defaultValue.push(element.val())
            }
            haveValidValues.push(element.valid())
          })
          if(phoneNumber0.length !== 0) {
            values.push([...phoneNumber0])
          }
          if(phoneNumber1.length !== 0) {
            values.push([...phoneNumber1])
          }
          if(phoneNumber2.length !== 0) {
            values.push([...phoneNumber2])
          }
          if(defaultValue.length !== 0) {
            values.push([...defaultValue])
          }
          dontValidate = haveValidValues.includes(false)
        }
        if (dontValidate) {
          return
        }
        values.forEach(async (value, valueIndex) => {
          const { isValid: isExternalValid, message, status } = await this.validateExternal({ validationType, value })
          this.externalValidations[validationType].push(isExternalValid)
          this.externalValidationsLoaded[validationType] = true
          if (!isExternalValid) {
            this.externalValidationErrors[validationType].push({
              message: `${message}`,
              code: status
            })
            if (validationType === 'email') {
              inputs.each((i, el) => {
                this.forceValidationError(el, message)
              })
            } else if (validationType === 'phone') {
              inputs.each((i, el) => {
                const element = $(el)
                if(values.length === 1 || element.prop('name').endsWith(valueIndex)) {
                  this.forceValidationError(el, message)
                }
              })
            }
            this.$emit('external-error')
          }
        })
      },
      resetExternalValidation({ data }) {
        const { validationType } = data
        this.externalValidationsLoaded[validationType] = false
        this.externalValidations[validationType] = []
        this.externalValidationErrors[validationType] = []
      },
      getValidationErrors() {
        const { errorList } = this.form.validate()
        this.validationErrors = errorList.map(err => {
          return {
            message: err.message,
            code: 400
          }
        })
      },
      /**
       * @vuese
       * Validates the form
       */
      validateForm() {
        return new Promise((resolve, reject) => {
          if (this.skipValidation) {
            return resolve()
          }
          this.form.validate()
          this.formValidation = this.form.valid()
          if (this.isLoading) {
            throw reject('busy')
          } else if (!this.formValidation) {
            this.getValidationErrors()
            throw reject({ type: 'validation', errors: this.validationErrors })
          } else if (!this.externalValid) {
            this.trackExternalValidationError(this.externalValidationErrors)
            return resolve()
          } else {
            return resolve()
          }
        })
      }
    }
  }
}
